// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `p {
  margin: 0;
}

h5 {
  margin: 1em 0 0.5em;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/rewards/bonuses/my-free-spin/my-free-spin.component.scss"],"names":[],"mappings":"AAAA;EACE,SAAA;AACF;;AAEA;EACE,mBAAA;AACF","sourcesContent":["p {\r\n  margin: 0;\r\n}\r\n\r\nh5 {\r\n  margin: 1em 0 0.5em;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
